import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import {
  getAllBusinessLines,
  createBusinessLine,
  deleteBusinessLine,
  updateBusinessLine,
} from '../../../services/businessLinesService';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import AddIcon from './plus.png';
import './BusinessLines.scss';
import {validNameandNumberEngMneRegex} from '../../../utils/const';
const BusinessLines = () => {
  const [businessLines, setBusinessLines] = useState([]);
  const [query, setQuery] = useState();
  const addButton = useRef();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllBusinessLines();
        setBusinessLines(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('businessLines.name'),
      editable: true,
      placeholder: t('businessLines.placeholder.name'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
       
        {max: 255, message: t('message.max', {max: 255})},
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('businessLines.nameEn'),
      editable: true,
      placeholder: t('businessLines.placeholder.nameEn'),
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {
          pattern: validNameandNumberEngMneRegex,
          message: t('message.fieldNotValid'),
        },
        { whitespace: true,
          message: t('message.fieldNotValid'),
        },
        {min: 3, message: t('message.min', {min: 3})},
        {max: 255, message: t('message.max', {max: 255})},
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await updateBusinessLine(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('businessLines.message.updateSuccess', {
            entity: t('businessLines.businessLine'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.businessLinesExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.businessLinesExists')],
          },
        ]);
      }
    }
  };
  const onCreate = async (data, form) => {
    data.nameEn = data.nameEn.trim();
    data.name = data.name.trim();
    try {
      const response = await createBusinessLine(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('businessLines.message.addSuccess', {
            entity: t('businessLines.businessLine'),
          }),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === 'name') {
        form.setFields([
          {
            name: 'name',
            errors: [t('message.businessLinesExists')],
          },
        ]);
      }
      if (err.response.data.detail === 'name_en') {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('message.businessLinesExists')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteBusinessLine'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            const response = await deleteBusinessLine(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('businessLines.message.deleteSuccess', {
                  entity: t('businessLines.businessLine'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {}
        },
      });
    });
  };

  return (
    <div className="users administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search-field">
          <SearchBox
            placeholder={t('businessLines.placeholder.search')}
            setQuery={setQuery}
          />
        </div>
        <div className="button-add">
          <button className="btn btn-primary" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('businessLines.add')}</p>
          </button>
        </div>
      </div>
      <CustomTable
        api="/business-lines"
        query={query}
        sort={getLanguage() === "eng" ? "nameEn" : "name"}
        queryParamName="name.contains"
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
      />
    </div>
  );
};

export default BusinessLines;
